// src/Components/TermsAndConditions.jsx
import React from 'react';
// ✅ 1. IMPORT THE CORRECT ICONS
import { FiFileText, FiCreditCard, FiEdit, FiXCircle, FiPauseCircle, FiGift, FiTruck, FiArchive, FiThumbsUp, FiMessageSquare, FiShield } from 'react-icons/fi';
// ✅ 2. CORRECT THE CSS IMPORT PATH
import './TermsAndConditions.css'; 

// Helper component to keep the main code clean
const TitledSection = ({ icon, title, children }) => (
  <div className="tnc-section">
    <div className="tnc-icon">{icon}</div>
    <div className="tnc-text">
      <h2 className="tnc-section-title">{title}</h2>
      {children}
    </div>
  </div>
);

const TermsAndConditions = () => {
  return (
    <div className="tnc-page">
      <div className="container">
        <h1 className="tnc-title">Terms & Conditions</h1>
        <p className="tnc-intro">
          Welcome to TOVEN. By subscribing to or purchasing our services, you agree to the following
          Terms & Conditions. Please read them carefully before proceeding.
        </p>
        
        <div className="tnc-content">
          <TitledSection icon={<FiFileText />} title="1. Subscription & Orders">
            <p>TOVEN offers flexible meal plans including Daily Meals, Fitness & Diet Plans, Add-ons & Sides, and Party Orders.</p>
            <p>Subscriptions are available for 3 days, 7 days, and 30 days. Single-day or trial meals may be offered under promotions.</p>
            <p>All orders are pre-order only to ensure freshness and minimize food waste.</p>
          </TitledSection>

          <TitledSection icon={<FiCreditCard />} title="2. Payments">
            <p>Payments must be made online via UPI, bank transfer, or QR code provided by TOVEN.</p>
            <p>Payments made directly to delivery executives are discouraged. If unavoidable, such payments must be immediately reported to TOVEN management.</p>
            <p>Subscription fees are collected in advance on a monthly basis, unless otherwise specified in a custom plan.</p>
          </TitledSection>

          <TitledSection icon={<FiEdit />} title="3. Modification Policy">
            <p>Customers may request plan modifications such as change of delivery address and other details must be informed at least 48 hours in advance via our official mail and WhatsApp.</p>
            <p>Same-day or last-minute modifications will not be encouraged.</p>
          </TitledSection>

          <TitledSection icon={<FiXCircle />} title="4. Cancellation & Refund Policy">
            <p>Cancellations require 24 hours' notice. Refunds are applicable only if more than 5 days remain in the subscription period.</p>
            <p>Refunds will be processed at 70% of the remaining balance (after deducting service and convenience charges).</p>
            <p>Refunds may take 5–7 business days to reflect in the customer's account.</p>
          </TitledSection>

          <TitledSection icon={<FiPauseCircle />} title="5. Pauses & Off-Days">
            <p><strong>For 30-day plans:</strong> Customers can pause up to 4 days with prior intimation before 6:00 PM of the previous day. A full refund as coins is provided for up to 4 days. If paused for more than 4 days, a 70% refund as coins will be provided.</p>
            <p><strong>For 7-day plans:</strong> Customers can pause for 1 day with prior intimation before 6:00 PM of the previous day. A full refund as coins is provided for 1 day. If paused for more than 1 day, a 70% refund as coins will be provided.</p>
            <p><strong>3-day trial plans:</strong> Pausing is not allowed.</p>
          </TitledSection>

          <TitledSection icon={<FiGift />} title="6. Coins & Wallet Usage">
            <p>Customers earn and use TOVEN Coins for adding funds, referral rewards, and promotional offers.</p>
            <p>Coins can be used to purchase Add-ons, Sides, and for partial payments for meal plans (when eligible).</p>
            <p>Coins are non-refundable, non-transferable, and subject to expiry timelines mentioned in offers.</p>
          </TitledSection>

          <TitledSection icon={<FiTruck />} title="7. Delivery Policy">
            <p>TOVEN strives for on-time delivery, but delivery slots are approximate. We are not liable for delays caused by incorrect address information.</p>
          </TitledSection>

          <TitledSection icon={<FiArchive />} title="8. Packaging & Steel Box Policy">
            <p>We use premium, spill-proof packaging. Eco-friendly steel box options are available for 7-day and 30-day subscribers with a refundable security deposit.</p>
            <p>Customers must rinse the steel box before returning it. TOVEN is not responsible for missing, damaged, or mistaken exchange of boxes after delivery.</p>
          </TitledSection>
          
          <TitledSection icon={<FiThumbsUp />} title="9. Customer Satisfaction">
            <p>If dissatisfied with meal quality, customers must report within 2 hours of delivery. Replacements or partial refunds will be considered on a case-by-case basis.</p>
          </TitledSection>

          <TitledSection icon={<FiMessageSquare />} title="10. Communication">
            <p>Customers must keep their contact details updated for smooth communication. TOVEN will use WhatsApp, SMS, Email, or App Notifications for important updates.</p>
          </TitledSection>

          <TitledSection icon={<FiShield />} title="11. Privacy Policy">
            <p>Customer data will be used only for service delivery, communication, and promotional purposes (with opt-out available) and will not be shared without consent.</p>
          </TitledSection>
          
          {/* ✅ 3. REPLACE FiGavel WITH FiShield */}
          <TitledSection icon={<FiShield />} title="12. Governing Law">
            <p>These Terms & Conditions are governed by the Food Safety and Standards Act (2006), Consumer Protection Act (2019), and applicable GST laws.</p>
          </TitledSection>

        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;